module.exports = __webpack_public_path__ + "static/media/copy-consumer-secret.9ec9fe18.gif";